import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import cx from 'classnames';
import { useStyles } from './styles';
import { setActivePlatform } from '../../redux/slices/podcastsSlice';
import ItunesIcon from '../../assets/images/apple-round-icon.png';
import SpotifyIconGreen from '../../assets/images/spotify-switch-icon-green.png';

const PLATFORMS = [
  {
    name: 'apple',
    icon: ItunesIcon,
    tooltipText: 'Switch to Apple Charts',
  },
  {
    name: 'spotify',
    icon: SpotifyIconGreen,
    tooltipText: 'Switch to Spotify Charts',
  },
];

const PlatformIcon = ({ platform, isActive }) => {
  const classes = useStyles();

  const iconElement = (
    <Box className={classes.iconWrapper}>
      <img src={platform.icon} alt={platform.name} className={classes.icon} />
    </Box>
  );

  if (isActive) {
    return iconElement;
  }

  return (
    <Tooltip title={platform.tooltipText} placement="top" arrow>
      {iconElement}
    </Tooltip>
  );
};

export const PlatformSwitch = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { activePlatform } = useSelector((state) => state.podcasts);

  const handlePlatformChange = (platformName) => {
    dispatch(setActivePlatform(platformName));
  };

  return (
    <Box className={classes.switchContainer}>
      {PLATFORMS.map((platform) => {
        const isActive = activePlatform === platform.name;

        return (
          <Box
            key={platform.name}
            className={cx(classes.switchOption, {
              [classes.activePlatform]: isActive,
            })}
            onClick={() => handlePlatformChange(platform.name)}
          >
            <PlatformIcon platform={platform} isActive={isActive} />
          </Box>
        );
      })}
    </Box>
  );
};
